export const appColors = {
  primary: "#20725B",
  secondary_one: "#189486",
  secondary_two: "#00535B",
  cta: "#007ACE",
  system: "#707090",
  system_background: "#F8F9FA",
  card_line_color: "#E2E2E9",
  toggle_active_color: "#4AB05A",
  white: '#FFFFFF',
  red: '#BF616A',
  warning: '#EBCB8B',
  success: '#A3BE8C'
}
